import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Divider,Message, Animation, } from 'rsuite';
import moment from 'moment-jalaali'
import 'moment/locale/fa' 
moment.locale('fa')


function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}

export class Transaction extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            trans: null
        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount() {


        Send('page/cart/payment/transaction', null, true).then((res) => {

            this.setState({ trans: res.data.trans });

        }).catch((err) => {});


    }



    render() {

        H1.page_name("سابقه پرداخت");



        return this.state.trans !== null && (




            <div className="h-100 mt-4">
                <div className='c-row'>
                    <div className="text-center mb-2 py-2 position-relative">
                        <span className='fs-6'>سابقه پرداخت</span>
                        <span className="icon-Back float-end fs-3" onClick={() => this.props.navigation(-1)} ></span>
                    </div>
                </div>


                <Animation.Slide in={true} placement="right">

                <div className="c-row text-center mt-4">


                    {this.state.trans === false &&

                        <Message showIcon type="info">
                            سابقه پرداختی برای شما وجود ندارد.
                        </Message>
                    }

                    {this.state.trans &&

                            this.state.trans.map((item, index) => [
                                <div className='notfy_box d-flex mt-4' key={index}>
                                    <div className='me-3'>

                                    {item.stus == 3 ?

                                    <span className="icon-Done ico s3"></span>
                                    :
                                    <span className="icon-Close ico s6"></span>
                                    }
                                                                            
                        
                                    
                                    </div>
                                    <div className='dis text-start fs-16'>
                                        {item.title}
                                        <div className={`fs-14 ${item.stus == 3 ? "cc-green" : 'cc-red' }`}> {H1.formatNumber(item.price)} تومان     <Divider vertical />  {item.stus == 3 ? "موفق" : 'ناموفق' }   </div>

                                        <div className='mt-1 fs-12 cc-2 ltr'>
                                        {moment(item.created_at).format('jYYYY/jM/jD - HH:mm')}
                                            </div>
                                    </div>
                                 
                                </div>
                            ])

                    }

                </div>
                        </Animation.Slide>





            </div>


        )
    }
}

export default withParams(Transaction);
